export default __webpack_public_path__ + "static/media/Export.a3d581ba.svg";